/**
 * ResidentLinks — a device row's residents as profile links, comma separated.
 *
 * `residents` is the list the Lambdas pack onto device rows ({ resident_id, resident_name }):
 * the device's own resident, or for an area device every active resident in its area.
 * Rows without the list (older procs, other sources) fall back to the single
 * resident_id / resident_name the row carries. Renders an em dash when there is no one.
 */

import { Link } from 'react-router-dom';

const ResidentLinks = ({ residents, residentId, residentName, linkClassName = 'ar-link' }) => {
    const list = Array.isArray(residents) && residents.length > 0
        ? residents
        : (residentId || residentName ? [{ resident_id: residentId, resident_name: residentName }] : []);
    if (list.length === 0) return '—';
    return list.map((r, i) => (
        <span key={r.resident_id || i}>
            {i > 0 ? ', ' : ''}
            {r.resident_id ? (
                <Link to={`/profiles/resident/${r.resident_id}`} className={linkClassName}>{r.resident_name || '—'}</Link>
            ) : (r.resident_name || '—')}
        </span>
    ));
};

export default ResidentLinks;
